module.exports = __webpack_public_path__ + "img/15.e5265968.jpg";